import axios from "axios";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";

import cookie from "vue-cookie";
import Vue from 'vue'

export const state = {  
};

export const getters = {
  isAuth() {
    if (cookie.get("ecampus")) {
      return true;
    } else {
      return false;
    }
  },
  JWToken() {
    if (cookie.get("ecampus")) {
      return CryptoJS.AES.decrypt(
        cookie.get("ecampus"),
        process.env.VUE_APP_SHA_KEY
      ).toString(CryptoJS.enc.Utf8);
    }
  }, 
 
 
  
  UserNameSurName(){
    let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
    let decodetoken = jwt_decode(token)
    return decodetoken.given_name + " " + decodetoken.family_name
},
UserFirsName(){
  let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
  let decodetoken = jwt_decode(token)
  return decodetoken.given_name 
},
UserLastName(){
  let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
  let decodetoken = jwt_decode(token)
  return decodetoken.family_name
},
UserEmail(){
  let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
  let decodetoken = jwt_decode(token)
  return decodetoken.email
},
AvatarUrl() {
  let token = CryptoJS.AES.decrypt(
    window.$cookies.get("ecampus"),
    process.env.VUE_APP_SHA_KEY
  ).toString(CryptoJS.enc.Utf8);
  return jwt_decode(token).avatar;
},
  UserRolles(){
      let token=CryptoJS.AES.decrypt(window.$cookies.get('ecampus'), process.env.VUE_APP_SHA_KEY).toString(CryptoJS.enc.Utf8)
      var roles = jwt_decode(token).roles
      if(roles){
       if(roles.constructor.name == "Array"){
        return jwt_decode(token).roles
       }else{
        var role = []
        role.push(jwt_decode(token).roles);
        return role
       } }else{
        return []
      }
  },  
};

export const mutations = {
  SetJWToken(state, JWToken) {
    var decoded = jwt_decode(JWToken).exp;
    decoded = new Date(decoded * 1000);
    //decoded.setHours( decoded.getHours() + 3 )
    let tokensifreleme = CryptoJS.AES.encrypt(
      JWToken,
      process.env.VUE_APP_SHA_KEY
    ).toString();
    window.$cookies.set(
      "ecampus",
      tokensifreleme,
      decoded,
      null,
      Vue.prototype.$config.COOKIES_DOMAIN
    );
    state.JWToken = tokensifreleme;
  }, 
  ClearJWToken(state) {
    window.$cookies.remove("ecampus",null,Vue.prototype.$config.COOKIES_DOMAIN);
    state.JWToken = null; 
  },
 
};

export const actions = {
 
  ActionsLogin({ commit }, Data) {
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/authenticate", Data)
      .then((res) => {
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.JWToken);
          commit("SetAuth", res.data.Data);
          return true;
        } else {
          return res;
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
  ResetPasswordLogin(_, Data) { 
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/reset-password", Data)
      .then((res) => {
        
          return res.data
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
UserUpdateLogin(_, Data) { 
    return axios
      .put(Vue.prototype.$config.API_ACCOUNT_URL + "Account/update", Data)
      .then((res) => {
        
          return res.data
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
  ActionsLoginSessionKey({ commit }, Data) {  
    return axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/authenticate", Data)
      .then((res) => { 
        console.log(res);
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.JWToken);
          commit("SetAuth", res.data.Data);
          return true;
        } else {
          return false; 
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
      ActionsLoginManisa({ commit }, Data) {  
              commit("SetJWToken", Data.JWToken);
              commit("SetAuth", Data.Data);
      },
  logOut({ commit }) {
    commit("ClearJWToken");
    commit("ClearAuth"); 
    window.location.href = "/login";
  },

  TokenRefreshZamanKontrol({ dispatch, getters }) {
    var decoded = jwt_decode(getters.JWToken);
    decoded = new Date(decoded.exp * 1000);
    let diffTime = Math.abs(new Date().valueOf() - decoded.valueOf());
    var kalanzaman = Math.floor(diffTime / 1000);
    if (kalanzaman < 90 && 0 < kalanzaman) {
      dispatch("ActionsRefreshToken");
    }
  },

  ActionsRefreshToken({ commit, dispatch, getters }) {
    let Data = { Token: getters.JWToken }; 
    axios
      .post(Vue.prototype.$config.API_ACCOUNT_URL + "Account/refresh-token", Data)
      .then((res) => {
        if (res.data.Succeeded == true) {
          commit("SetJWToken", res.data.Data.Token);  
          dispatch("TokenZamaniHesaplama"); 
        }
      })
      .catch((error) => error.response.data)
      .catch((error) => {
        console.log(JSON.parse(JSON.stringify(error.response.data.errors)));
      });
  },
  TokenZamaniHesaplama({  dispatch,state }) { 
    if(!getters.JWToken)dispatch("logOut");
    else{
        var decoded = jwt_decode(
        CryptoJS.AES.decrypt(
          state.JWToken,
          process.env.VUE_APP_SHA_KEY
        ).toString(CryptoJS.enc.Utf8));
    
        decoded = new Date(decoded.exp * 1000); 
        let diffTime = Math.abs(new Date().valueOf() - decoded.valueOf());
      /*  var kalanzaman = Math.floor(diffTime / 1000);
        kalanzaman = (kalanzaman - 60) * 1000;  */
      //  dispatch("CookiesZamanKontrol", kalanzaman);
    }
  },


  CookiesZamanKontrol({ dispatch, commit }, kalanzaman) {
    setTimeout(
      function() {
        var mevcuttoken =CryptoJS.AES.decrypt(
          cookie.get("ecampus"),
          process.env.VUE_APP_SHA_KEY
        ).toString(CryptoJS.enc.Utf8);

        var tokenkontrol = setInterval(
          function() { 
            let sifrecoz = CryptoJS.AES.decrypt(
              cookie.get("ecampus"),
              process.env.VUE_APP_SHA_KEY
            ).toString(CryptoJS.enc.Utf8); 
            if (sifrecoz != mevcuttoken) {
              Swal.close();
              clearInterval(timerInterval); 
              clearInterval(tokenkontrol);  
              commit("SetJWToken", sifrecoz);
              dispatch("TokenZamaniHesaplama"); 
            } 
          }.bind(this),
          100
        );

        let timerInterval;
        Swal.fire({
          title: "Oturum Süreniz Dolmak Üzere",
          html: "Son <b>60</b> saniye süreniz kaldı.",
          timer: 60000,
          timerProgressBar: true,
          confirmButtonText: "Devam",
          onBeforeOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
              Swal.getHtmlContainer().querySelector("b").textContent = (
                Swal.getTimerLeft() / 1000
              ).toFixed(0);
            }, 1000);
          },
          onClose: () => {
            clearInterval(timerInterval); 
            clearInterval(tokenkontrol); 
          },
        }).then((result) => {
          if (
            result.dismiss === Swal.DismissReason.timer
          ) {
            dispatch("logOut");
          }
          if (result.value) {
            clearInterval(timerInterval); 
            dispatch("ActionsRefreshToken");
          } else { 
            dispatch("logOut");
          }
        });
      }.bind(this),
      kalanzaman
    );
  } 
};
